import React from 'react';
import { observer } from "mobx-react-lite";
import { useTranslation } from 'react-i18next';
import { StringActionDetail } from './components/StringActionDetail';
import { DisplayMode, TranslatedStringActionDetail } from './components/TranslatedStringActionDetail';
import { Dropdown } from '../../editor/Dropdown';
import { allEditorComplexities, localSettingsStore } from '../../../stores/LocalSettingsStore';
import { BooleanActionDetail } from './components/BooleanActionDetail';
export const TreePropertiesActionDetails = observer(({
  action
}) => {
  const {
    t
  } = useTranslation();

  if (!localSettingsStore.isProductionEditor) {
    return /*#__PURE__*/React.createElement("div", null, t("action_editor.only_available_in_production_editor"));
  }

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TranslatedStringActionDetail, {
    name: t("editor.translated_name"),
    translatedString: action.localizedName,
    allowBlankValue: false,
    displayMode: DisplayMode.Simple
  }), /*#__PURE__*/React.createElement("div", null, t("editor.item_tags"), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("input", {
    type: "text",
    value: action.tags.join(" "),
    onChange: ({
      target
    }) => action.setTags(target.value.split(" "))
  })), /*#__PURE__*/React.createElement(TranslatedStringActionDetail, {
    name: t("action_editor.property_description"),
    translatedString: action.description,
    displayMode: DisplayMode.Simple,
    allowBlankValue: true
  }), /*#__PURE__*/React.createElement(TranslatedStringActionDetail, {
    name: t("action_editor.property_tutorial"),
    translatedString: action.tutorial,
    displayMode: DisplayMode.Simple,
    allowBlankValue: true
  }), /*#__PURE__*/React.createElement(StringActionDetail, {
    name: t("action_editor.property_color"),
    value: action.color,
    valueSetter: action.setColor.bind(action),
    allowBlankValue: true
  }), /*#__PURE__*/React.createElement(StringActionDetail, {
    name: t("action_editor.property_icon"),
    value: action.icon,
    valueSetter: action.setIcon.bind(action),
    allowBlankValue: true
  }), /*#__PURE__*/React.createElement("div", null, t("action_editor.property_complexity_gate"), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(Dropdown, {
    value: action.complexityGate,
    onChange: e => action.setComplexityGate(+e.target.value)
  }, allEditorComplexities.map(complexity => /*#__PURE__*/React.createElement("option", {
    key: complexity,
    value: complexity
  }, t("editor.local_setting_complexity_" + complexity))))), /*#__PURE__*/React.createElement("div", null, t("action_editor.property_minimum_complexity"), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(Dropdown, {
    value: action.minimumComplexity,
    onChange: e => action.setMinimumComplexity(+e.target.value)
  }, allEditorComplexities.map(complexity => /*#__PURE__*/React.createElement("option", {
    key: complexity,
    value: complexity
  }, t("editor.local_setting_complexity_" + complexity))))), /*#__PURE__*/React.createElement(BooleanActionDetail, {
    name: t("action_editor.property_exclude_from_translations"),
    checked: action.excludeFromTranslations,
    toggle: action.toggleExcludeFromTranslations.bind(action)
  }));
});